import { render, staticRenderFns } from "./book-video.vue?vue&type=template&id=61a2b008"
import script from "./book-video.vue?vue&type=script&lang=js"
export * from "./book-video.vue?vue&type=script&lang=js"
import style0 from "./book-video.vue?vue&type=style&index=0&id=61a2b008&prod&scope=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports